import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Breadcrums from "../../../common/breadcrumbs";
import Loader from "../../../common/loader";
import { capitalizeFirstLetter, formateDate } from "../../../../../utils/commonfunction";
import * as learnHubServices from "../../../services/learnHub.services";
import VideoModal from "./VideoModal";

const ViewLearnHub = () => {
  const navigate = useNavigate();
  const params = useParams();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showVideoModal, setShowVideoModal] = useState(false);
  const [showAllComments, setShowAllComments] = useState(false);
  const maxVisible = 3;

  const breadcrumbs = [
    { title: "Dashboard", url: "/admin/dashboard" },
    { title: "Courses & Webinars", url: "/admin/cms/learn-hub/list/1" },
    { title: "View", url: "" },
  ];

  useEffect(() => {
    learnHubServices.Details(params.id)
      .then((res) => {
        if (res?.success && res?.data) {
          setData(res.data);
        }
      })
      .catch(console.error)
      .finally(() => setLoading(false));
  }, [params.id]);

  if (loading) return <Loader />;
  if (!data) {
    return (
      <div className="text-center py-5">
        <h4>No data found</h4>
        <button className="btn btn-dark mt-3" onClick={() => navigate(-1)}>Back</button>
      </div>
    );
  }

  return (
    <>
      <Breadcrums data={breadcrumbs} />

      <VideoModal
        show={showVideoModal}
        onClose={() => setShowVideoModal(false)}
        videoUrl={data.video_source === "upload" ? data.streamURL : null}
        youtubeUrl={data.video_source === "youtube" ? data.video_link : null}
        title={data.title}
      />

      <div className="row row-sm">
        <div className="col-lg-12 col-md-12 animation_fade">
          <div className="card custom-card">
            <div className="card-body">
              <div className="d-flex justify-content-between align-items-center mb-4">
                <h6 className="main-content-label">View Courses & Webinars Content</h6>
                <button className="btn ripple btn-dark" onClick={() => navigate(-1)}>Back</button>
              </div>

              <table className="table table-bordered">
                <tbody>
                  <tr>
                    <th width="200">Title</th>
                    <td>{capitalizeFirstLetter(data.title) || "N/A"}</td>
                  </tr>
                  <tr>
                    <th>Content Type</th>
                    <td>
                      <span className="badge bg-info text-white">
                        {data.content_type === "lesson" ? "Video Lesson" : capitalizeFirstLetter(data.content_type)}
                      </span>
                    </td>
                  </tr>
                  {data.content_type === "lesson" && (
                  <tr>
                    <th>Video Source</th>
                    <td>
                      <span className={`badge ${data.video_source === "upload" ? "bg-success" : "bg-primary"}`}>
                        {data.video_source === "upload" ? "Uploaded Video" : "YouTube"}
                      </span>
                    </td>
                  </tr>)}

                  {/* VIDEO PREVIEW */}
                  <tr>
                    <th>{data.content_type === "lesson" ? "Video Preview" : "Image Preview"}</th>
                    <td>
                      {data.thumbnail ? (
                        <div className="position-relative d-inline-block">
                          <img
                            src={data.thumbnail}
                            alt="Thumbnail"
                            className="rounded shadow"
                            style={{ height: "220px", cursor: data.content_type === "lesson" ? "pointer" : "default" }}
                            onClick={() => data.content_type === "lesson" && setShowVideoModal(true)}
                          />
                          {data.content_type === "lesson" &&
                          <div className="position-absolute top-50 start-50 translate-middle cp" onClick={() => setShowVideoModal(true)}>
                            <div className="bg-dark bg-opacity-75 rounded-circle p-4">
                              <i className="fa fa-play text-white fa-4x"></i>
                            </div>
                          </div>}
                        </div>
                      ) : (
                        <span className="text-muted">No thumbnail</span>
                      )}

                      {(data.streamURL || data.video_link) && (
                        <div className="mt-4">
                          <button
                            className="btn btn-primary btn-lg d-flex align-items-center gap-2"
                            onClick={() => setShowVideoModal(true)}
                          >
                            Play Video
                          </button>
                          <div className="mt-3">
                            <small className="text-muted">
                              {data.video_source === "upload" ? (
                                <>
                                  <strong>{data.video_filename}</strong> • {(data.file_id?.size / 1024 / 1024).toFixed(2)} MB
                                </>
                              ) : (
                                <strong>YouTube Video</strong>
                              )}
                            </small>
                          </div>
                        </div>
                      )}
                    </td>
                  </tr>

                  {/* LIKES & COMMENTS COUNT */}
                  <tr>
                    <th>Engagement</th>
                    <td>
                      <div className="d-flex gap-4">
                        <span>
                          <i className="fa fa-thumbs-up text-primary"></i> <strong>{data.likes_count || 0}</strong> Likes
                        </span>
                        <span>
                          <i className="fa fa-comments text-success"></i> <strong>{data.comments_count || 0}</strong> Comments
                        </span>
                      </div>
                    </td>
                  </tr>

                  <tr>
                    <th>Created On</th>
                    <td>{formateDate(data.createdAt)}</td>
                  </tr>
                  <tr>
                    <th>Last Updated</th>
                    <td>{formateDate(data.updatedAt)}</td>
                  </tr>
                </tbody>
              </table>

               {/* DESCRIPTION */}
              <div className="mt-5">
                <h6 className="main-content-label mb-3">Description</h6>
                <div
                  className="border p-4 rounded bg-light"
                  style={{ minHeight: "150px" }}
                  dangerouslySetInnerHTML={{
                    __html: data.description || "<em>No description provided</em>",
                  }}
                />
              </div>

              {/* COMMENTS SECTION */}
              {data.comments && data.comments.length > 0 && (
                <div className="mt-5">
                  <h6 className="main-content-label mb-3">
                    Comments ({data.comments_count})
                  </h6>

                  <div className="border rounded p-4 bg-light">
                    {(showAllComments ? data.comments : data.comments.slice(0, maxVisible)).map((c) => (
                      <div key={c._id} className="d-flex mb-3 pb-3 border-bottom">
                        <div className="me-3">
                          {c.user_image ? (
                            <img
                              src={c.user_image}
                              alt={c.user_name}
                              className="rounded-circle"
                              style={{ width: "40px", height: "40px", objectFit: "cover" }}
                            />
                          ) : (
                            <div
                              className="bg-secondary rounded-circle d-flex align-items-center justify-content-center text-white"
                              style={{ width: "40px", height: "40px" }}
                            >
                              {c.user_name[0]?.toUpperCase()}
                            </div>
                          )}
                        </div>
                        <div className="flex-grow-1">
                          <strong>{c.user_name}</strong>
                          <small className="text-muted ms-2">
                            {new Date(c.created_at).toLocaleString()}
                          </small>
                          <p className="mb-0 mt-1">{c.comment}</p>
                        </div>
                      </div>
                    ))}

                    {/* Show More / Show Less Button */}
                    {data.comments.length > maxVisible && (
                      <button
                        className="btn btn-link mt-2 p-0"
                        onClick={() => setShowAllComments(!showAllComments)}
                      >
                        {showAllComments ? "Show Less" : "Show More Comments"}
                      </button>
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ViewLearnHub;